import { Clickable, H2, Image, PortableText, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media, mediaQueries } = theme;

export const Container = styled.div`
  max-width: 46.25rem;
  margin: 0 auto;
  padding: 6rem 1rem;

  ${mediaQueries.above(media.sm)} {
    padding: 7.5rem 0 5rem;
  }
`;

export const InnerContainer = styled.div`
  max-width: 33.25rem;
  margin: 0 auto;
`;

export const Description = styled(H2)`
  font-weight: normal;
`;

export const BodyContent = styled(PortableText)`
  padding-top: 2rem;
`;

export const MainImage = styled(Image)`
  margin-bottom: 3.5rem;
  width: 100%;
`;

export const BodyImage = styled(Image)`
  width: 100%;
`;

export const RelativeContainer = styled.div`
  position: relative;
`;

export const BackButton = styled(Clickable)`
  position: absolute;
  font-weight: 600;
  top: 3rem;
  left: 1rem;

  ${mediaQueries.above(media.md)} {
    left: 2.5rem;

    &:hover {
      text-decoration: underline;
      text-decoration-thickness: 3px;
    }
  }
`;
